import { render, staticRenderFns } from "./dataListTest.vue?vue&type=template&id=fcf9c846&scoped=true"
import script from "./dataListTest.vue?vue&type=script&lang=js"
export * from "./dataListTest.vue?vue&type=script&lang=js"
import style0 from "./dataListTest.vue?vue&type=style&index=0&id=fcf9c846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf9c846",
  null
  
)

export default component.exports